import React from "react";
import PropTypes from "prop-types";

export function ContentDescription(props) {
  return (
    <div className={props.className}>
      <h3 className={`${props.className}_title`}>{props.title}</h3>
      <p className={`${props.className}_description`}>{props.description}</p>
    </div>
  );
}

ContentDescription.propTypes = {
  /**
   * ClassName to set on component
   */
  className: PropTypes.string,
  /**
   * Title of description section
   */
  title: PropTypes.string,
  /**
   * Description text to render on component
   */
  description: PropTypes.string,
};

ContentDescription.defaultProps = {};
